import requestPortalCaseEditing from './request_portal_case_editing';
import requestPortalCaseLoading from './request_portal_case_loading';
import requestPortalCaseMapping from './request_portal_case_mapping';
import requestPortalCasePayloads from './request_portal_case_payloads';

export default {
  ...requestPortalCaseEditing,
  ...requestPortalCasePayloads,
  ...requestPortalCaseLoading,
  ...requestPortalCaseMapping,
};
